<template>
  <div class="gx-csk">
    <!-- <h1 class="gx-main__title">低价引流检测</h1> -->

    <!-- 红色 Tab（与个人设置一致） -->
    <div class="gx-csk__tabs">
      <button
        v-for="t in tabs"
        :key="t.id"
        class="gx-csk__tab"
        :class="{ 'gx-csk__tab--on': activeTab === t.id }"
        @click="switchTab(t.id)"
      >
        {{ t.label }}
      </button>
    </div>

    <!-- 检测内容 -->
    <div v-if="activeTab === 'content'" class="gx-csk__panel">
      <check-lower-price ref="checkLowerPriceRef" :info="previewInfo" @submitted="onSubmitted" @view-list="onViewList" />
    </div>

    <!-- 检测列表 -->
    <div v-else-if="activeTab === 'list'" class="gx-csk__panel">
      <sku-check-list ref="skuCheckListRef" @view-abnormal="onViewAbnormal" />
    </div>

    <!-- 检测异常 -->
    <div v-else class="gx-csk__panel">
      <sku-check-abnormal-list ref="skuCheckAbnormalListRef" />
    </div>
  </div>
</template>

<script>
import CheckLowerPrice from './uc_checkSku/checkLowerPrice.vue'
import SkuCheckList from './uc_checkSku/skuCheckList.vue'
import SkuCheckAbnormalList from './uc_checkSku/skuCheckAbnormalList.vue'

export default {
  name: 'NewCheckSkuPage',
  components: { CheckLowerPrice, SkuCheckList, SkuCheckAbnormalList },
  data() {
    return {
      tabs: [
        { id: 'content', label: '检测内容' },
        { id: 'list', label: '检测列表' },
        { id: 'abnormal', label: '检测异常' }
      ],
      activeTab: 'content',
      previewInfo: null,
      taskNo: ''
    }
  },
  created() {
    const taskNo = this.$route.query.task_no || ''
    if (taskNo) {
      this.taskNo = taskNo
      this.activeTab = 'abnormal'
      this.$nextTick(() => {
        if (this.$refs.skuCheckAbnormalListRef) {
          this.$refs.skuCheckAbnormalListRef.initData(taskNo)
        }
      })
    }
  },
  methods: {
    switchTab(id) {
      this.activeTab = id
      this.$nextTick(() => {
        if (id === 'content' && this.$refs.checkLowerPriceRef) {
          this.$refs.checkLowerPriceRef.getFirstInfo && this.$refs.checkLowerPriceRef.getFirstInfo()
        }
        if (id === 'list' && this.$refs.skuCheckListRef) {
          this.$refs.skuCheckListRef.initData && this.$refs.skuCheckListRef.initData()
        }
        if (id === 'abnormal' && this.$refs.skuCheckAbnormalListRef) {
          this.$refs.skuCheckAbnormalListRef.initData && this.$refs.skuCheckAbnormalListRef.initData(this.taskNo)
        }
      })
    },
    onSubmitted(taskNo) {
      this.taskNo = taskNo || ''
      this.activeTab = 'list'
      this.$nextTick(() => {
        if (this.$refs.skuCheckListRef) {
          this.$refs.skuCheckListRef.initData && this.$refs.skuCheckListRef.initData()
        }
      })
    },
    onViewList() {
      this.activeTab = 'list'
      console.log(45545)
      this.$nextTick(() => {
        if (this.$refs.skuCheckListRef) {
          this.$refs.skuCheckListRef.initData && this.$refs.skuCheckListRef.initData()
        }
      })
    },
    onViewAbnormal(taskNo) {
      this.taskNo = taskNo || ''
      this.activeTab = 'abnormal'
      this.$nextTick(() => {
        if (this.$refs.skuCheckAbnormalListRef) {
          this.$refs.skuCheckAbnormalListRef.initData && this.$refs.skuCheckAbnormalListRef.initData(this.taskNo)
        }
      })
    }
  }
}
</script>

<style scoped>
.gx-csk__tabs {
  display: flex;
  border-bottom: 1px solid #E0E0EC;
  margin-bottom: 20px;
}
.gx-csk__tab {
  padding: 9px 22px;
  border: none;
  cursor: pointer;
  font-size: 13px;
  color: #4A4A6A;
  border-bottom: 2px solid transparent;
  transition: all .15s;
  background-color: #FFFFFF;
}
.gx-csk__tab--on {
  color: #C8443C;
  font-weight: 600;
  border-bottom-color: #C8443C;
}
.gx-csk__panel {
  /* background: #FFFFFF;
  border-radius: 12px;
  border: 1px solid #E1E5EE;
  padding: 20px;
  min-height: 300px; */
}
</style>
